import React, { forwardRef } from "react";
import styled from "styled-components";

import useViewStore from "../../store/useViewStore";

const FormField = forwardRef(({ children, ...props }, ref) => {
  const { isMobileView } = useViewStore((state) => state);

  return (
    <Field $isMobileView={isMobileView} ref={ref} {...props}>
      {children}
    </Field>
  );
});

const Field = styled.div`
  margin-bottom: 24px;
  flex: 1;
  ${props => props.$isMobileView ? `width: 100%;` : `width: 300px;`};
`;

export default FormField;